import { Tag } from "antd";
import { HeartOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Price } from "../../../components/__simple/_price";
import { useTranslation } from "react-i18next";
export const theme = {
  colors: {
    primary: "#00b362",
    textPrimary: "#000000",
    textSecondary: "#6B7280",
    danger: "#DC2626",
    success: "#16A34A",
    border: "#E5E7EB",
    bgMuted: "#F9FAFB",
  },

  fontSize: {
    xs: "12px",
    sm: "13px",
    base: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    title: "22px",
  },

  fontWeight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export default function AlternativeProductCard({ item }) {
  const { t: trans } = useTranslation([]);
  return (
    <div className="border rounded-xl p-4 space-y-5">
      {/* العنوان + أيقونات */}
      <div className="flex justify-between items-start">
        <div>
          <div
            style={{
              fontSize: theme.fontSize.md,
              fontWeight: theme.fontWeight.semibold,
            }}>
            {item.DescriptionAr}
          </div>

          <div
            style={{
              fontSize: theme.fontSize.sm,
              color: theme.colors.textSecondary,
              direction: "ltr",
            }}>
            {item.ProductNo}
          </div>
        </div>

        <div className="flex gap-3 text-lg">
          <HeartOutlined style={{ width: "3rem" }} />
          <span className="opacity-50"></span>
        </div>
      </div>

      {/* الأسعار */}
      <div className="flex gap-3 items-center">
        {/* <span
          className="line-through"
          style={{
            fontSize: theme.fontSize.sm,
            color: theme.colors.textSecondary,
          }}>
          ﷼ {item.oldPrice}
        </span>

        <span
          style={{
            fontSize: theme.fontSize.lg,
            fontWeight: theme.fontWeight.bold,
            color: theme.colors.primary,
          }}>
          ﷼ {item.price}
        </span> */}

        <span className={"text-20 text-gray mx-1"}>{trans("info:product_price")}</span>
        <span className={"price text-primary  text-20"}>
          <Price price={item.SalesPrice} />
        </span>
      </div>

      {/* نفاذ من المخزون */}
      {item.StockTotalQty <= 0 && (
        <div className="bg-gray-50 border rounded-lg p-3 flex gap-2 items-start">
          <InfoCircleOutlined className="text-red-600 mt-1" style={{ width: "2rem" }} />
          <div>
            <div
              style={{
                fontSize: theme.fontSize.sm,
                fontWeight: theme.fontWeight.medium,
              }}>
              نفذت من المخزون
            </div>
            <div
              style={{
                fontSize: theme.fontSize.xs,
                color: theme.colors.textSecondary,
              }}>
              هذه القطعة نفذت من المخزون
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
